import React from "react"
import ProgressCard, { iProgressCardDataItem } from "./ProgressCard"
import { iGDM_CALC_STRUCTURE } from "../Structure"
import BMICard from "./BMICard"

interface iProgressPanel {
  data: {
    [id: string]: iProgressCardDataItem
  }
  calculatorStructure: iGDM_CALC_STRUCTURE
}

const ProgressPanel: React.FC<iProgressPanel> = ({
  data,
  calculatorStructure,
}) => {
  const getDataAttr = (
    data: { [id: string]: iProgressCardDataItem },
    key: string
  ) => {
    const ATTR = data[key]
    if (!ATTR) return null
    const { value, error, warning } = ATTR
    if (error || warning) return null
    if (isNaN(parseFloat(value))) return null
    return parseFloat(value)
  }

  return (
    <>
      <ProgressCard data={data} calculatorStructure={calculatorStructure} />
      <div className="py-3" />
      <BMICard
        height={getDataAttr(data, "height")}
        weight={getDataAttr(data, "pre_pregnancy_weight")}
      />
    </>
  )
}

export default ProgressPanel
